import { useConfirm } from 'components/Alert/useConfirm';
import { useMutation } from 'query';
import { reject } from 'scenes/FinancePage/FR/data/queryKeyFactory';
import { rejectFR } from 'scenes/FinancePage/FR/sources';

export const useReject = () => {
  const confirm = useConfirm();

  const approveMutation = useMutation(reject(), rejectFR, {
    refresh: true,
    successMessage: () => `Financial Result rejected`,
  });

  const handleAction = ({ id }: any) => {
    confirm({
      title: `Reject Financial Result ${id}?`,
      confirmActionLabel: 'Reject',
    }).then(() => approveMutation.mutateAsync({ id }));
  };

  return [handleAction, approveMutation];
};
